/* eslint-disable */
import MPWorkplace from "@/utils/MPWorkplace";

window.$ = require("jquery");
window._ = require("lodash");
window.moment = require("moment-timezone");

window.axios = MPWorkplace.newAxios();

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "flag-icon-css/sass/flag-icon.scss";
import "@babel/polyfill";
